import { render, staticRenderFns } from "./HandicapPriceSpreadController.vue?vue&type=template&id=5e6a1ba2&scoped=true&"
import script from "./HandicapPriceSpreadController.vue?vue&type=script&lang=js&"
export * from "./HandicapPriceSpreadController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6a1ba2",
  null
  
)

export default component.exports